export default "/images/7ec9ec5f62b047f78724f6a95ca89247.avif";